import { useEffect, useState } from "react";
import { Button, Modal } from "cai-fusion";

import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useSiftV2 } from "../../../contexts/siftV2Context";

const UpdateOpportunityStateModal = ({newState}) => {

    const { hide, visibilityStates } = useTransientVisibility();

	const [reason, setReason] = useState("");
	const { currOpp, currAction, takeAction } = useSiftV2();
	
	useEffect(() => {
		if(!visibilityStates.UpdateOpportunityStateModal){
			setReason("");
		}
	}, [visibilityStates.UpdateOpportunityStateModal])

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			if (!event.shiftKey) {
				event.preventDefault();
				// renameChat(reason);
				hide('UpdateOpportunityStateModal');
				setReason("");
			}
		}
	};

	return (
		<Modal
			isHidden={ !visibilityStates.UpdateOpportunityStateModal }
			id="rename-modal"
			clickOutsideToClose={ true }
			title="Updating Opportunity State"
			onClose={(e) => {
				hide('UpdateOpportunityStateModal');
				e.preventDefault();
			}}
			actions={
				<>
					<Button outline onClick={(e) => { e.preventDefault(); setReason(""); hide('UpdateOpportunityStateModal'); }} children="Cancel"/>
					<Button onClick={(e) => { 
						e.preventDefault();
						takeAction(reason);
						setReason("");
						hide('UpdateOpportunityStateModal'); 
					}} children="Submit"/>
				</>
			}
		>
			<div className="l-row">
				<div className="l-one-col">
					<p>To change the status of your opportunity{(currOpp?.request?.currentState?.name && newState !== "" ) && <> from <strong>{currOpp?.request?.currentState?.name}</strong> to <strong>{newState}</strong></>}, please provide a reason that will be documented for later viewing.</p>
					<form action="" className="o-form">
						<div className="m-form-group l-mt-sm">
							<label htmlFor="" className="a-label">Status Update Reason</label>
							<textarea rows={3} value={reason} onKeyDown={(e) => handleKeyPress(e)} onChange={(e) => { setReason(e.target.value); e.preventDefault(); }} className="a-text-input"/>
						</div>
					</form>
                    <p>Please review this carefully before submission, as it can only be undone by an administrator.</p>
				</div>
			</div>
		</Modal>
	);
};

export default UpdateOpportunityStateModal;